var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.73077L17 8M12 9.73077L7 8M12 9.73077V17M17 3H19C20.1046 3 21 3.89543 21 5V7M17 21H19C20.1046 21 21 20.1046 21 19V17M7 3H5C3.89543 3 3 3.89543 3 5V7M7 21H5C3.89543 21 3 20.1046 3 19V17M12.6486 6.22239L16.6486 7.59382C17.457 7.87098 18 8.63114 18 9.48571V13.9724C18 14.7551 17.5434 15.4659 16.8315 15.7913L12.8315 17.6199C12.3035 17.8613 11.6965 17.8613 11.1685 17.6199L7.16848 15.7913C6.45661 15.4659 6 14.7551 6 13.9724V9.48572C6 8.63114 6.54297 7.87098 7.35135 7.59382L11.3514 6.22239C11.7718 6.07825 12.2282 6.07825 12.6486 6.22239Z",
    stroke: "#F2F5F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.49e06e6d897eb22c59d04a3302ed94f4.svg";
export { ForwardRef as ReactComponent };